
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Package, BarChart3, Users } from "lucide-react";

const QuickActions = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
        <CardDescription>Common tasks to manage your store</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <a 
          href="/products" 
          className="flex items-center w-full p-3 text-left border rounded-lg hover:bg-gray-50 transition-colors"
        >
          <Package className="mr-3 h-4 w-4" />
          <div>
            <p className="font-medium">View Products</p>
            <p className="text-sm text-gray-600">Manage your product listings</p>
          </div>
        </a>
        <a 
          href="/reports" 
          className="flex items-center w-full p-3 text-left border rounded-lg hover:bg-gray-50 transition-colors"
        >
          <BarChart3 className="mr-3 h-4 w-4" />
          <div>
            <p className="font-medium">View Analytics</p>
            <p className="text-sm text-gray-600">Check your sales reports</p>
          </div>
        </a>
        <a 
          href="/orders" 
          className="flex items-center w-full p-3 text-left border rounded-lg hover:bg-gray-50 transition-colors"
        >
          <Users className="mr-3 h-4 w-4" />
          <div>
            <p className="font-medium">Manage Orders</p>
            <p className="text-sm text-gray-600">View and process orders</p>
          </div>
        </a>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
